import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaxEntryComponent } from './tax-entry/tax-entry.component';
import { UsCapitalGainsComponent } from './us-capital-gains/us-capital-gains.component';
import { UsTaxComponent } from './us-tax/us-tax.component';
import { SharedModule } from '@shared/shared.module';
import { UsTaxService } from './services/us-tax.service';
import { UsCapitalGainsService } from './services/us-capital-gains.service';
import { UsCapitalGainsListingComponent } from './us-capital-gains/us-capital-gains-listing/us-capital-gains-listing.component';
import { UsCapitalGainsFiltersComponent } from './us-capital-gains/us-capital-gains-filters/us-capital-gains-filters.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { UsTaxDistributionsComponent } from './us-tax/us-tax-distributions/us-tax-distributions.component';
import { TranslateModule } from '@shared/translate/translate.module';
import { UsCapitalGainsEstimatesComponent } from './us-capital-gains-estimates/us-capital-gains-estimates.component';
import { UsCapitalGainsEstimatesFiltersComponent } from './us-capital-gains-estimates/us-capital-gains-estimates-filters/us-capital-gains-estimates-filters.component';
import { UsCapitalGainsEstimatesListingComponent } from './us-capital-gains-estimates/us-capital-gains-estimates-listing/us-capital-gains-estimates-listing.component';
import { AgGridModule } from '@ag-grid-community/angular';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { FundNameCellRendererComponent } from './us-capital-gains-estimates/us-capital-gains-estimates-listing/ag-grid-helpers/fund-name-cell-renderer/fund-name-cell-renderer.component';
import {
  DynamicTableModule,
  FlyoutMenuModule,
  StickyFooterModule,
} from '@frk/eds-components';
import { FundSelectCellRendererComponent } from './us-capital-gains-estimates/us-capital-gains-estimates-listing/ag-grid-helpers/fund-select-cell-renderer/fund-select-cell-renderer.component';
import { FundSelectAllHeaderRendererComponent } from './us-capital-gains-estimates/us-capital-gains-estimates-listing/ag-grid-helpers/fund-select-all-header-renderer/fund-select-all-header-renderer.component';
import { UsCapitalGainsEstimatesCardsComponent } from './us-capital-gains-estimates/us-capital-gains-estimates-listing/us-capital-gains-estimates-cards/us-capital-gains-estimates-cards.component';
import { TaxListInfoComponent } from './tax-list-info/tax-list-info.component';
import { TaxListInfoFiltersComponent } from './tax-list-info/tax-list-info-filters/tax-list-info-filters.component';
import { TaxInfoRowComponent } from './tax-list-info/tax-info-row/tax-info-row.component';
import { TaxListInfoPrintComponent } from './tax-list-info/tax-list-info-print/tax-list-info-print.component';

@NgModule({
  declarations: [
    TaxEntryComponent,
    UsCapitalGainsComponent,
    UsCapitalGainsListingComponent,
    UsCapitalGainsFiltersComponent,
    UsTaxComponent,
    UsTaxDistributionsComponent,
    UsCapitalGainsEstimatesComponent,
    UsCapitalGainsEstimatesFiltersComponent,
    UsCapitalGainsEstimatesListingComponent,
    FundNameCellRendererComponent,
    FundSelectCellRendererComponent,
    FundSelectAllHeaderRendererComponent,
    UsCapitalGainsEstimatesCardsComponent,
    TaxListInfoComponent,
    TaxListInfoFiltersComponent,
    TaxInfoRowComponent,
    TaxListInfoPrintComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    NgxSpinnerModule,
    AgGridModule,
    StickyFooterModule,
    FlyoutMenuModule,
    DynamicTableModule,
  ],
  entryComponents: [
    TaxEntryComponent,
    UsTaxComponent,
    UsCapitalGainsComponent,
    TaxListInfoComponent,
  ],
  providers: [UsTaxService, UsCapitalGainsService],
})
export class TaxModule implements DynamicModule {
  constructor() {
    ModuleRegistry.registerModules([ClientSideRowModelModule]);
  }

  getComponentMapping(): ComponentMapping {
    return {
      'Fund Tax': TaxEntryComponent,
    };
  }
}
